module.exports = __webpack_public_path__ + "img/E2 DP3.245f9ce8.png";